import React, { createContext, useState } from 'react';
import { useLocation } from 'react-router-dom';

export const POContext = createContext();

const POContextProvider = (props) => {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);

  const statusParam = searchParams.get('status');
  const podLeaderParam = searchParams.get('podLeader');
  const currencyParam = searchParams.get('currency');
  const dateApprovedFromParam = searchParams.get('dateApprovedFrom');
  const dateApprovedToParam = searchParams.get('dateApprovedTo');
  const grossFromParam = searchParams.get('grossFrom');
  const grossToParam = searchParams.get('grossTo');

  const [filterStatus, setFilterStatus] = useState(statusParam || 'none');
  const [filterPodLeader, setFilterPodLeader] = useState(
    podLeaderParam ? parseInt(podLeaderParam, 10) : ''
  );

  const [filterCurrency, setFilterCurrency] = useState(
    currencyParam ? parseInt(currencyParam, 10) : ''
  );
  const [filterStartFrom, setFilterStartFrom] = useState('');
  const [filterStartTo, setFilterStartTo] = useState('');
  const [filterEndFrom, setFilterEndFrom] = useState(
    dateApprovedFromParam ? new Date(dateApprovedFromParam) : ''
  );
  const [filterEndTo, setFilterEndTo] = useState(
    dateApprovedToParam ? new Date(dateApprovedToParam) : ''
  );
  const [filterStartFromAmount, setFilterStartFromAmount] = useState(
    grossFromParam || ''
  );
  const [filterStartToAmount, setFilterStartToAmount] = useState(grossToParam || '');

  const [filterTo, setFilterTo] = useState('');
  const [filterFrom, setFilterFrom] = useState('');

  const [from, setFrom] = useState('');
  const [to, setTo] = useState('');

  const [fromStart, setFromStart] = useState('');
  const [toStart, setToStart] = useState('');

  const [fromEnd, setFromEnd] = useState('');
  const [toEnd, setToEnd] = useState('');

  const [fromAmount, setFromAmount] = useState('');
  const [toAmount, setToAmount] = useState('');

  return (
    <POContext.Provider
      value={{
        filterStatus,
        setFilterStatus,
        filterPodLeader,
        setFilterPodLeader,
        filterCurrency,
        setFilterCurrency,
        filterStartFrom,
        setFilterStartFrom,
        filterStartTo,
        setFilterStartTo,
        filterEndFrom,
        setFilterEndFrom,
        filterEndTo,
        setFilterEndTo,
        filterFrom,
        setFilterFrom,
        filterTo,
        setFilterTo,
        filterStartFromAmount,
        setFilterStartFromAmount,
        filterStartToAmount,
        setFilterStartToAmount,
        fromAmount,
        setFromAmount,
        toAmount,
        setToAmount,
        from,
        setFrom,
        to,
        setTo,
        fromStart,
        setFromStart,
        toStart,
        setToStart,
        fromEnd,
        setFromEnd,
        toEnd,
        setToEnd,
      }}
    >
      {props.children}
    </POContext.Provider>
  );
};

export default POContextProvider;
